import { PublicApiVideo } from './Interface/Video';
import { OnDemandVideoPlayer } from './OnDemandVideoPlayer';

export const Video: PublicApiVideo = {
    playOnDemand: async function (src: string, element: HTMLElement): Promise<void> {
        await OnDemandVideoPlayer.playVideoOnDemand(src, element);
    },
};
